import {
  hasOnlyLetters,
  validateCpf,
  validateEmailRegex,
  validatePhone,
} from '@/utils/validates';
import * as yup from 'yup';
import { strongPasswordValidation } from './password';

export const registerFormSchema = yup
  .object()
  .shape({
    agreePrivacyPolicy: yup
      .boolean()
      .isTrue(
        'Para se cadastrar, você deve concordar com os termos de uso e a política de privacidade'
      ),
    cpf: yup
      .string()
      .required('Digite um CPF para prosseguir!')
      .test('is-valid-cpf-cadastre', 'Digite um CPF válido', cpf =>
        validateCpf(cpf?.replace(/\D/g, '') || '')
      ),
    phone: yup
      .string()
      .test(
        'is-10-length',
        'Digite um número de telefone válido',
        phone => !(phone && phone.length < 10)
      )
      .test(
        'is-valid-number',
        'Digite um telefone válido',
        async phone =>
          !(
            phone &&
            !(await validatePhone(phone || Array(10).fill('1').join('')))
          )
      ),
    email: yup
      .string()
      .required('Email é um campo obrigatório.')
      .max(80, 'Você excedeu o limite de caracteres no campo e-mail')
      .matches(validateEmailRegex, 'Digite um e-mail válido'),
    name: yup
      .string()
      .required('Nome é um campo obrigatório.')
      .max(60, 'Você excedeu o limite de caracteres no campo nome')
      .test(
        'hasOnlyLetters',
        'Nome não pode conter números ou caracteres especiais',
        value => !!value?.match(hasOnlyLetters)
      ),
    re_password: yup
      .string()
      .oneOf([yup.ref('password'), null], 'As senha informadas não coincidem')
      .required('Repita a senha'),
  })
  .concat(strongPasswordValidation);
